import { render } from "./crfViewsingle.vue?vue&type=template&id=7ced2fea&scoped=true"
import script from "./crfViewsingle.js?vue&type=script&lang=js"
export * from "./crfViewsingle.js?vue&type=script&lang=js"

import "./crfViewsingle.vue?vue&type=style&index=0&id=7ced2fea&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ced2fea"]])

export default __exports__